export const removeDuplicates = (array, key) => {
  const lookup = new Set();
  return array.filter(obj => !lookup.has(obj[key]) && lookup.add(obj[key]));
};
